import  Url  from "../../address";

const addressUser = Url + "/user/user";
const addressContact = Url + "/user/contact";

export default { addressUser, addressContact };
